import ReactSplit, { SplitDirection } from "@devbookhq/splitter"
import { t } from "i18next"
import { memo, useEffect } from "react"
import { selectUndoable } from "../../helpers/selector.helpers"
import { useAppDispatch, useAppSelector } from "../../hooks/useRedux"
import { setOpenSaveForm, setOpenVersionHistoryDetail } from "../../store/slices/editor.slice"
import { ScrollableContainer } from "../../style/styles"
import GraphicSaveForm from "../Graphic/GraphicSaveForm"
import EmptyPanel from "../common/EmptyPanel"
import AnimationTools from "./AnimationsNavbar/AnimationTools"
import ObjectTools from "./RightSideNavbar/ObjectTools"
import VersionHistoryForm from "./VersionHistoryForm"

export const OBJECT_TOOL_CLASSNAME = "object-tools"

const RightSideNavbar = () => {
    const dispatch = useAppDispatch()
    useEffect(() => {
        return () => {
            dispatch(setOpenSaveForm(false))
            dispatch(setOpenVersionHistoryDetail(false))
        }
    }, [dispatch])

    const { visibleSaveForm, versionHistoryDetail } = useAppSelector((state) => state.editor.value)

    const objects = useAppSelector((state) => selectUndoable(state).objects.value)
    const selectedObjectIds: string[] = useAppSelector((state) => state.activeObject.selected)
    const selectedAnimationsIds: string[] = useAppSelector(
        (state) => state.activeAnimation.selected
    )

    if (visibleSaveForm) {
        return (
            <ScrollableContainer className={OBJECT_TOOL_CLASSNAME}>
                <GraphicSaveForm />
            </ScrollableContainer>
        )
    } else if (versionHistoryDetail) {
        return (
            <ScrollableContainer className={OBJECT_TOOL_CLASSNAME}>
                <VersionHistoryForm />
            </ScrollableContainer>
        )
    } else {
        if (selectedAnimationsIds.length === 0 && selectedObjectIds.length === 0)
            return (
                <EmptyPanel
                    title={t("editor:emptyPanel.rightSideNavBar.title")}
                    subtitle={t("editor:emptyPanel.rightSideNavBar.subtitle")}
                    className={OBJECT_TOOL_CLASSNAME}
                />
            )
        else if (selectedObjectIds.length >= 1 && selectedAnimationsIds.length < 1)
            return <ObjectTools objectId={selectedObjectIds[0]} />
        else if (selectedObjectIds.length >= 1 && selectedAnimationsIds.length >= 1)
            return (
                <ReactSplit
                    direction={SplitDirection.Vertical}
                    initialSizes={[60, 40]}
                    gutterClassName="panel-gutter-vertical"
                    draggerClassName="panel-gutter-grip"
                >
                    <ObjectTools objectId={selectedObjectIds[selectedObjectIds.length - 1] ?? ""} />
                    <AnimationTools
                        animationId={selectedAnimationsIds[0]}
                        object={objects[selectedObjectIds[selectedObjectIds.length - 1]]}
                    />
                </ReactSplit>
            )
        else return <></>
    }
}

export default memo(RightSideNavbar)
